<ng-container *transloco="let t">
  <ng-container *ngIf="(groups$ | async)?.length > 0">
    <form [formGroup]="form" class="group-and-children-filter">
      <ng-container *ngIf="showGroup">
        <ng-select
          id="group"
          formControlName="groupUuid"
          [items]="groups$ | async"
          bindLabel="label"
          bindValue="uuid"
          [clearable]="false"
          class="form-control form-control-rounded group-select"
          [ngClass]="{ active: !!form.get('groupUuid')?.value }"
          [typeahead]="fetchGroups$"
        ></ng-select>
      </ng-container>
      <ng-container *ngIf="showChildren && form.get('groupUuid')?.value">
        <ng-select
          id="children"
          formControlName="childrenUuids"
          [items]="children$ | async"
          bindLabel="label"
          bindValue="childUuid"
          [placeholder]="placeholderText"
          [multiple]="true"
          class="form-control form-control-rounded multiple-no-selected dark-placeholder child-select"
          [ngClass]="{ active: (form.get('childrenUuids')?.value?.length ?? 0) > 0 }"
          [typeahead]="fetchChildren$"
        >
        </ng-select>
      </ng-container>
    </form>
  </ng-container>
</ng-container>
